import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Parses the current URL search string into a {@link URLSearchParams} object.
 * The result is memoized and only recomputed when the location search string changes.
 *
 * @returns A {@link URLSearchParams} instance for the current route's query string.
 *
 * @example
 * const query = useSearchQuery();
 * const page = query.get('page'); // '2'
 */
export default function useSearchQuery(): URLSearchParams {
	const { search } = useLocation();
	return React.useMemo(() => new URLSearchParams(search), [search]);
}
